import React, { useRef, useEffect, useContext } from 'react'
import Lottie from 'lottie-web'
import AuthContext from '../../../context/userAuth.context';

const AtoZCharacter = (props) => {
    
    const { authenticationData } = useContext(AuthContext)

    const refnew = useRef()

    useEffect(() => {
        // Compared without case, but the address is used as it is (lower-casing it loaded the file
        // a second time and fails on servers with case-sensitive file names).
        let filePath = props.FileName;
        if (!props.FileName.toLowerCase().includes(authenticationData.ApiBaseURL.toLowerCase())) {
            filePath = authenticationData.ApiBaseURL + "/" + props.FileName
        }
        let name = props.value.AnimationId + 'AtoZ'
        Lottie.loadAnimation({
            container: refnew.current,
            name: name,
            renderer: 'svg',
            loop: true,
            autoplay: true,
            path: filePath,
            rendererSettings: {
                viewBoxOnly: true,
                progressiveLoad: true,
            }
        })
        return () => {
            Lottie.destroy(name)
        }
    }, [])

    return (
        <div className={(props.value.Editable == true ? 'RectBorder' : '')}
            style={{
                transform: props.value.flip, width: '100%', height: '100%', position: 'absolute', top: '0px', opacity: props.value.opacity, zIndex: - 1
            }}>
            <div ref={refnew} />
        </div>
    );
};


export default AtoZCharacter;
